import React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import { AppDispatch } from 'reducers/index';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import { Link } from '@zola/zola-ui/src/components/Link';
import { isMobile } from '@zola-helpers/client/dist/es/util/responsive';
import { hideModal } from '../../../../actions/modalActions';
import styles from './styles.module.less';

type CreateFreeGuestListProps = {
  onCancel: () => void;
  onConfirm: () => void;
};

const CreateFreeGuestList = ({ onCancel, onConfirm }: CreateFreeGuestListProps) => (
  <>
    <div className={styles.guestHeader}>Create your free guest list</div>
    <div className={styles.content}>
      <ol className={styles.createNewGuestListInfo}>
        <li>Collect everyone&apos;s addresses in a flash</li>
        <li>Track RSVPs, plus ones, and meal selections</li>
        <li>Sync it all up with your Zola paper and seating charts</li>
      </ol>
      <Link
        arrow
        target="_blank"
        rel="noopener noreferrer"
        href="https://help.zola.com/hc/en-us/articles/115002148572-What-is-the-Guest-List-tool-"
      >
        Learn More
      </Link>
    </div>
    <div className={cx(styles.buttonContainer, styles.guesListButtonContainer)}>
      {isMobile() ? (
        <>
          <ButtonV2 onClick={onConfirm} fullWidth={isMobile()}>
            Get Started
          </ButtonV2>
          <ButtonV2
            className={styles.cancelbtn}
            variant="secondary"
            onClick={onCancel}
            fullWidth={isMobile()}
          >
            Maybe Later
          </ButtonV2>
        </>
      ) : (
        <>
          <ButtonV2
            className={styles.cancelbtn}
            variant="secondary"
            onClick={onCancel}
            fullWidth={isMobile()}
          >
            Maybe Later
          </ButtonV2>
          <ButtonV2 onClick={onConfirm} fullWidth={isMobile()}>
            Get Started
          </ButtonV2>
        </>
      )}
    </div>
  </>
);

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  onConfirm: () => {
    dispatch(hideModal());
    window.open('/wedding/manage/guests/all', '_blank');
  },
  onCancel: () => dispatch(hideModal()),
});

export default connect(null, mapDispatchToProps)(CreateFreeGuestList);
